import React from "react";
import * as ChartTypes from "constants/ChartTypes";
import classnames from "classnames";

export default class ChartTypeSelector extends React.Component {
	selectChartType(chartType) {
		this.props.onChartTypeSelect(chartType);
	}
	render() {
		let classes = classnames({
			"chartTypeSelector": true,
			"dropdown": true,
			"open": this.props.showDropDown
		});
		return (
			<div className={classes} data-intro="Choose a Chart Type, Candlestick, Line, Point & Figure and more ">
					<button type="button" className="btn btn-default" onClick={this.props.onDropDownToggle}>
						{this.props.chartType.label} <span className="caret"></span>
					</button>
					<ul className="dropdown-menu dropdown-menu-left" role="menu">
						<li key="basicChartTypes" className="dropdown-header">Basic Charts</li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.AREA)}>{ChartTypes.AREA.label}</a></li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.LINE)}>{ChartTypes.LINE.label}</a></li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.CANDLESTICK)}>{ChartTypes.CANDLESTICK.label}</a></li>
						<li key="advancedChartTypes" className="dropdown-header">Advanced Charts</li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.HEIKIN_ASHI)}>{ChartTypes.HEIKIN_ASHI.label}</a></li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.RENKO)}>{ChartTypes.RENKO.label}</a></li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.KAGI)}>{ChartTypes.KAGI.label}</a></li>
						<li><a href="#" onClick={this.selectChartType.bind(this, ChartTypes.POINT_FIGURE)}>{ChartTypes.POINT_FIGURE.label}</a></li>
					</ul>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ChartTypeSelector.jsx
 **/